import styled, { css } from 'styled-components';

import { ButtonProps } from './Button';
import { ButtonColor } from './types';
import { hexToRgba } from '../../../features/Theme/domain/color';

export const buttonStyleTypes = {
	primary: 'primary',
	secondary: 'secondary',
	link: 'link',
};

const primary = (color: ButtonColor, disabled: boolean): boolean => {
	return buttonStyleTypes.primary === color && !disabled;
};

const secondary = (color: ButtonColor, disabled: boolean): boolean => {
	return buttonStyleTypes.secondary === color && !disabled;
};

const link = (color: ButtonColor): boolean => {
	return buttonStyleTypes.link === color;
};

const primaryDisabled = (color: ButtonColor, disabled: boolean): boolean => {
	return buttonStyleTypes.primary === color && disabled;
};

const secondaryDisabled = (color: ButtonColor, disabled: boolean): boolean => {
	return buttonStyleTypes.secondary === color && disabled;
};

export const ButtonContainer = styled.button<ButtonProps>`
	${({ theme, $color, disabled = false, $rounded = false, $loading = false, $block }) => css`
		display: ${$loading ? 'grid' : 'flex'};
		align-items: center;
		justify-content: center;

		user-select: none;

		${!$rounded && `height: ${link($color) ? 'calc(1rem * 2.5)' : 'calc(1rem * 3.9375)'};`}
		${$rounded && !link($color) && 'height: 48px;'}
		
		${!$rounded && `width: ${$block ? '100%' : !link($color) && 'calc(1rem * 19.125)'};`}
		${$rounded && !link($color) && 'min-width: 140px;'}
		
		${!$block && `max-width: ${!link($color) && 'calc(1rem * 19.125)'}`};
		${link($color) && 'padding: 0 calc(1rem * 1.25);'};
		${$rounded && 'padding-left: 34px;'};
		${$rounded && 'padding-right: 34px;'};
		border-radius: ${$rounded ? theme.radii.l : theme.radii.default};
		text-align: center;
		font-size: ${theme.fontSizes.m};
		font-weight: ${theme.fontWeights.regular};
		cursor: ${disabled ? 'not-allowed' : 'pointer'};
		border: none;
		color: ${() =>
		(primary($color, disabled) && '#ffffff') ||
			(secondary($color, disabled) && theme.colors.brand.primary[300]) ||
			(secondaryDisabled($color, disabled) && '#ffffff') ||
			(primaryDisabled($color, disabled) && '#ffffff')};

		background-color: ${() =>
		(primary($color, disabled) && theme.colors.brand.accent[300]) ||
			(secondary($color, disabled) && theme.colors.neutral[200]) ||
			(link($color) && 'transparent') ||
			(primaryDisabled($color, disabled) && theme.colors.brand.primaryDisabled) ||
			(secondaryDisabled($color, disabled) && '#F1F1F1')};

		&:hover {
			${primary($color, disabled) &&
			`background-color: ${hexToRgba(theme.colors.brand.accent[300], 0.8)};`}
		}
	`}
`;
